/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Capability_AdvancedInputs */



/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Model_Showcase_Capability_AdvancedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_capability_advanced = /** @type {((inputs?: Model_Showcase_Capability_AdvancedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Capability_AdvancedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortgeschritten")
	return /** @type {LocalizedString} */ ("Advanced")
});